import request from './axios';

let date = Date.now();

//主要用表单提交post,put方法
function requestCoreOne(type) {
    return function (url, params) {
        let ret = '';
        for (let it in params) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(params[it]) + '&';
        }
        return request({
            method: type,
            url: `${url}?${ret}`,
        })
    }
}

//主要用json提交post,put方法
function requestCoreThree(type) {
    return function (url, params) {
        return request({
            method: type,
            url: url,
            data: params,
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}

//主要用于文件上传
function requestCoreFore(type) {
    return function (url, params) {
        return request({
            method: type,
            url: url,
            data: params,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
//下载返回流的形式  主要用json提交post方法
function requestCoreFive(type) {
    return function (url, params) {
        return request({
            method: type,
            url: url,
            data: params,
            responseType:"blob",
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}
//主要用于get请求
function requestCoreTwo(type) {
    return function (url, params) {
        return request({
            method: type,
            url: url,
            params: params
        })
    }
}

//主要用于get请求
function requestCoreTwoLinux(type) {
    return function (url, params, baseUrl) {
        return request({
            method: type,
            url:url,
            params: params,
            baseURL:baseUrl
        })
    }
}

//下载返回流的形式  主要用于get请求
function requestBlobDownload(type) {
    return function (url, params) {
        return request({
            method: type,
            url:url,
            params: params,
            responseType:"blob",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    }
}

export const getRequest = requestCoreTwo('get')
export const getRequestLinux = requestCoreTwoLinux('get')
export const getRequestBlob = requestBlobDownload('get')


export const deleteRequest = requestCoreTwo('delete')
export const postRequest = requestCoreOne('post')
export const putRequest = requestCoreOne('put')
export const postRequest2 = requestCoreThree('post')
export const putRequest2 = requestCoreThree('put')
export const postRequest3 = requestCoreFore('post')
export const postRequest4 = requestCoreFive('post')

